import { render, staticRenderFns } from "./PassExamList.vue?vue&type=template&id=2af2d4bd&"
import script from "./PassExamList.vue?vue&type=script&lang=js&"
export * from "./PassExamList.vue?vue&type=script&lang=js&"
import style0 from "./PassExamList.vue?vue&type=style&index=0&id=2af2d4bd&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports